import BaseTransformer from "./base.transformer"

export const baseUri = "/api/account-details"
class AccountDetailTransformer extends BaseTransformer {
  static fetch(accountDetail) {
    const uuid = this.transformUuid(accountDetail)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      logo: accountDetail?.logo?.uri,
      accountName: accountDetail.accountName,
      contactPhone: accountDetail.contactPhone,
      contactName: accountDetail.contactName,
      contactEmail: accountDetail.contactEmail,
      companyName: accountDetail.companyName,
      companySize: accountDetail.companySize,
      companyIndustry: accountDetail.companyIndustry,
      address: accountDetail.address,
      city: accountDetail.city,
      country: accountDetail.country
    })
  }
}

export default AccountDetailTransformer
